// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Y8Xx6","title":"index_title_X4M-o","titleText":"index_titleText_iY7oa"};